@let tokensPacks = tokensPacks$ | async;



<div class="modal-content">


    <h1>{{ 'plans.buttons.buy_more_tokens' | translate }}</h1>

    <table align="center">
        <tbody>
            @for(tokensPack of (tokensPacks ?? []); track $index){
            <tr>
                <!-- <th  class="pack-name">
                    <lucide-angular [name]="tokensPack.icon"/>{{tokensPack.name}}
                </th> -->
                <th scope="row">
                    <div class="quantity"><lucide-angular name="coins" />{{tokensPack.tokensQuantity}}</div>
                </th>
                <th>{{tokensPack.price}}</th>
                <th>
                    <div class="action">
                        <!-- désactive les tokens packs pour la béta -->
                        <app-button type="discreet" [disabled]="tokensPack.priceId !== 'price_1SE9ZTR1X5dLdyWjAQtPGg85'"
                            (click)="tokensPackClick.emit(tokensPack)">{{ 'common.buy' |
                            translate }}</app-button>
                    </div>
                </th>
            </tr>
            }
        </tbody>
    </table>
</div>